import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/** Loyalty receives server-calculated prices/points with each variant response. */
class LoyaltyMessage extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section')?.addEventListener(ThemeEvents.variantUpdate, this.#onVariant);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section')?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariant);
  }

  #onVariant = (event) => {
    const next = event.detail.data.html.querySelector(`loyalty-message[data-block-id="${this.dataset.blockId}"]`);
    const content = next?.querySelector('[data-loyalty-content]');
    const current = this.querySelector('[data-loyalty-content]');
    if (!content || !current) return;
    current.replaceWith(content.cloneNode(true));
    this.dataset.productId = next.dataset.productId;
    this.updatedCallback();
  };
}

if (!customElements.get('loyalty-message')) customElements.define('loyalty-message', LoyaltyMessage);
